import React from 'react';
import { ReactData } from '../data/WorkData';

const Projects = () => {
  return (
    <section id="projects">
      <h1>Projects</h1>
      <ul className="academic-list">
        {ReactData.map((project, index) => (
          <li key={index}>
            <h3>{project.title}</h3>
            <div className="date">{project.tech.join(', ')}</div>
            <div className="desc">{project.desc}</div>
            <div className="project-links">
              {project.gitlink && <a href={project.gitlink} target="_blank" rel="noreferrer">Code</a>}
              {project.site && <a href={project.site} target="_blank" rel="noreferrer">Live Site</a>}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Projects;
